import axios from "axios";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import React, { Component } from "react";
import { useAuth } from "../auth/AuthContext";

const API_KEY = process.env.REACT_APP_API_URL;

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();

  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post(`${API_KEY}/api/auth/login`, { email, password })
      .then((result) => {
        if (result?.data.success) {
          const userData = result?.data;

          // localStorage.setItem("user", JSON.stringify(result?.data));
          login(userData);

          const role = userData.user.role;
          if (role === "admin" || role === "user") {
            window.location.href = "/create";
          } else {
          window.location.href = "/login";
          }
        }
      })
      .catch((err) => {
        setError("Login failed. Please try again.");
      });
  };

  return (
    <div className="d-flex justify-content-center align-items-center bg-secondary vh-100">
      <div className="p-3 rounded w-25 ">
        <h2>Sign in to your account</h2>
        {error && <p className="text-danger">{error}</p>}
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="email" className="mb-2">
              <strong>Email</strong>
            </label>
            <input
              type="email"
              placeholder="Enter Email"
              autoComplete="off"
              className="form-control rounded-0"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="mb-2">
              <strong>Password</strong>
            </label>
            <input
              type="password"
              placeholder="Enter Password"
              autoComplete="off"
              className="form-control rounded-0"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-purple text-white w-100">
            Login
          </button>
        </form>
        <p className="mt-2">Don't have an account?</p>
      </div>
    </div>
  );
}

export default Login;
